// src/index.js

import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter as Router } from "react-router-dom"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import customTheme from "./theme"
import { ChakraProvider } from "@chakra-ui/react"
import AuthProvider from "./auth/AuthProvider"
import store from "./store"
import { Provider } from "react-redux"

import { PostHogProvider } from "posthog-js/react"
import posthog from "posthog-js"

import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client"
import { queryClient, queryPersister, dehydrateOptions } from "./queryClient"

const container = document.getElementById("root")
const root = createRoot(container)

const posthogOptions = {
	api_host: process.env.REACT_APP_PUBLIC_POSTHOG_API_HOST,
	capture_pageleave: true,
	capture_pageview: true,
	session_recording: {
		maskTextSelector: ".sensitive"
	},
	// Add environment as a global property to all events
	loaded: (posthog) => {
		posthog.register({
			environment: process.env.NODE_ENV,
			hostname: window.location.hostname
		})
	}
}

// Always initialize PostHog if API key is available
if (process.env.REACT_APP_PUBLIC_POSTHOG_API_KEY) {
	posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_API_KEY, posthogOptions)
}

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<ChakraProvider theme={customTheme}>
				<PostHogProvider client={posthog}>
					<Router>
						<AuthProvider>
							<PersistQueryClientProvider
								client={queryClient}
								persistOptions={{
									persister: queryPersister,
									maxAge: 1000 * 60 * 60 * 24,
									buster: "v4",
									dehydrateOptions
								}}
							>
								<App />
							</PersistQueryClientProvider>
						</AuthProvider>
					</Router>
				</PostHogProvider>
			</ChakraProvider>
		</Provider>
	</React.StrictMode>
)

reportWebVitals()
